// import React from 'react';
// import './Integration.scss';
// import ContentLoader from 'react-content-loader';

// const InstaPost = ({
//   data,
//   hideShowDataSource,
//   arrDataSource,
//   handleDataSource,
//   userIntegration,
//   createInstagram,
//   deleteInstagram,
//   handleStateChangeInt,
//   validator,
//   hideShowIntegration
// }) => {
//   userIntegration = userIntegration && userIntegration.length > 0 && userIntegration.filter(x => x.inm == 'instagrampost');
//   return (
//     <div>
//       <div className="title-dataset-select">
//         <div className="dataset-select-header" >
//           <svg onClick={() => hideShowDataSource()} className="link-svg" xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20">
//             <path id="collsapn-arrow" d="M11.587,10.928,2.565,19.951a1.111,1.111,0,0,1-1.568,0l-.665-.665a1.111,1.111,0,0,1,0-1.568L7.909,10.14.324,2.557a1.111,1.111,0,0,1,0-1.568L.988.324a1.111,1.111,0,0,1,1.568,0l9.03,9.03a1.12,1.12,0,0,1,0,1.574Z" transform="translate(11.894 20) rotate(-177)" fill="#8FA7C4" />
//           </svg>
//           <div className="title-dataset-label cursor" onClick={() => hideShowDataSource()}>
//             <img className="mr-2" src={data.img} alt="icon" />
//             <h6>{data.dn}</h6>
//           </div>
//           {userIntegration && userIntegration.length > 0 && data.isHideShowInt == false && <div className="integr-inside-hdright" onClick={() => hideShowIntegration()}>
//             <div className="add-integra-btn text-center" >
//               <a className="nf-btn tbl-seehty-btn">Add New</a>
//             </div>
//           </div>}
//         </div>
//         {((typeof userIntegration == 'undefined' || typeof userIntegration == 'boolean') || (data.isHideShowInt == true)) && <div className="wdgt-group-block wdgt-group-ggplace">
//           <div className="wdgt-group-input mt-25">
//             <label>User name</label>
//             <input className="nf-input nf-input-sm" name="un" name="un" placeholder="Enter User name" value={data.un} onChange={handleStateChangeInt} />
//             {validator.message('url', data.un, 'required|required')}
//           </div>
//           <div className="wdgt-group-input mt-15">
//             <label>Name your connection</label>
//             <input className="nf-input nf-input-sm" name="rmk" value={data.rmk} placeholder="Name your connection" onChange={handleStateChangeInt} />
//             {validator.message('connection', data.rmk, 'required|required')}
//           </div>
//           <div className="add-integra-btn text-center" onClick={(e) => createInstagram(e)}>
//             <a className="nf-btn nf-btn-default">Add New</a>
//           </div>
//         </div>}
//         {userIntegration && userIntegration.length > 0 && <div className="integre-search--list">
//           <input
//             className="nf-input nf-input-sm input-left-inicon input-left-iconsearch input-left-visitor"
//             placeholder="Search by name"
//             type="text"
//             name="searchByName"
//             value={data.searchByName}
//             onChange={(e) => handleStateChangeInt(e)}
//           />
//         </div>}
//         {data.islstIntLoading === true ?
//           <ContentLoader
//             height={750}
//             width={1750}
//             speed={2}
//             primaryColor="#fff"
//             secondaryColor="#eceef4"
//           >
//             <rect x="150" y="40" rx="0" ry="0" width="1500" height="700"></rect>
//           </ContentLoader>
//           :
//           userIntegration && userIntegration.length > 0 ?
//             userIntegration.map((usInt, key) => {
//               if (usInt._id == data.usIntId) usInt.ia = data.intISActive ? data.intISActive : false;
//               let defaultChecked = arrDataSource.filter((dataSource) => {
//                 if (dataSource.uid == usInt._id) return true; return false;
//               }).length > 0 ? true : false;
//               let objCountParams = {
//                 pglkcnt: 0,
//                 pgflcnt: 0,
//                 pgrtngcnt: 0,
//                 pgrtngavg: 0,
//                 pu: '',
//                 iin: usInt.inm,
//                 rmk: usInt.rmk,
//                 url: usInt.d.url,
//                 dn: usInt.d.dn ? usInt.d.dn : ''
//               };
//               return (new RegExp(data.searchByName, 'i').test(usInt.rmk) == true && <div className="card-editor card-intigra-block card-intigra-ggpalceislist" key={key}>
//                 <div className="integra-checklist-item" >
//                   <div className="secstyle-checkbox secstyle-checkbox-sm  itgtion-icon-checkboc ">
//                     <label>
//                       <input type="checkbox"
//                         name={usInt.d.place_id}
//                         checked={defaultChecked}
//                         onChange={(e) => handleDataSource(
//                           usInt._id,
//                           usInt._id,
//                           e.target.checked,
//                           objCountParams
//                         )}
//                       />
//                     </label>
//                   </div>
//                   <span className="">{usInt.rmk}</span>
//                   <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt"
//                     onClick={() => deleteInstagram(usInt._id)}>
//                     <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
//                       <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
//                         <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
//                         <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
//                       </g>
//                     </svg>
//                   </span>
//                 </div>
//               </div>);
//             }) : ''}
//       </div>
//     </div>
//   );
// };

// export default InstaPost;


import React from 'react';
import './Integration.scss';
import IntHeader from './IntHeader';
import Dropdown from 'react-dropdown';
import ContentLoader from 'react-content-loader';
// data,
// hideShowDataSource,
// arrDataSource,
// handleDataSource,
// userIntegration,
// createInstagram,
// deleteInstagram,
// handleStateChangeInt,
// validator,
// hideShowIntegration
const InstaPost = ({
  hideShowDataSource,
  userIntegration,
  data,
  loading,
  // arrDataSource,
  // handleDataSource,
  deleteInstagram,
  profile,
  createInstaPostInt,
  deleteInstaPostInt,
  // state,
  disableOnCreateInt
  // handleStateChangeInt,
}) => {

  let disableBTN = false;
  if (loading === true) {
    disableBTN = true;
  }
  else if (data.isCreatingIntegration === true) {
    disableBTN = data.isCreatingIntegration;
  }

  const redirectFB = () => {
    disableOnCreateInt();
    let currentURL = window.location.href.replace(/&/gi, '@');
    let objStateFB = {
      uk: profile._id,
      ti: profile.ti,
      uri: currentURL + '@tb=ds',//window.location.href,
      path: window.location.pathname
    };
    // localStorage.setItem('W_WDGT_CRT', JSON.stringify({
    //   wdsc: state.wdsc,
    //   widgetById: state.widgetById,
    //   currLayoutId: state.currLayoutId,
    //   currCardId: state.currCardId,
    //   currHtnpp: state.currHtnpp,
    //   isEditWidget: state.isEditWidget,
    // }));
    let redirect_uri = process.env.REACT_APP_INT_API_URL;
    // let redirect_uri = 'https://13a35de1bb78.ngrok.io/api';
    let authURL = 'https://www.facebook.com/v9.0/dialog/oauth?client_id=' +
      process.env.REACT_APP_FB_APP_ID +
      '&redirect_uri=' +
      redirect_uri +
      '/instapost/oauth&scope=email,pages_show_list,public_profile,pages_read_engagement,pages_read_user_content,instagram_basic&response_type=code&state=' + JSON.stringify(objStateFB);
    window.open(authURL, '_self');
  };

  userIntegration = userIntegration && userIntegration.length > 0 && userIntegration.filter(x => x.inm == 'instagrampost');
  return (
    <div>
      <div className="title-dataset-select">
        {/* <div className="dataset-select-header" >
          <svg onClick={() => hideShowDataSource()} className="link-svg" xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20">
            <path id="collsapn-arrow" d="M11.587,10.928,2.565,19.951a1.111,1.111,0,0,1-1.568,0l-.665-.665a1.111,1.111,0,0,1,0-1.568L7.909,10.14.324,2.557a1.111,1.111,0,0,1,0-1.568L.988.324a1.111,1.111,0,0,1,1.568,0l9.03,9.03a1.12,1.12,0,0,1,0,1.574Z" transform="translate(11.894 20) rotate(-177)" fill="#8FA7C4" />
          </svg>
          <div className="title-dataset-label cursor" onClick={() => hideShowDataSource()}>
            <img className="mr-2" src={data.img} alt="icon" />
            <h6>{data.dn}</h6>
          </div>
        </div> */}
        <IntHeader
          data={data}
          hideShowDataSource={hideShowDataSource}
        />
        <div className="integr-inside-hdright wdgt-dataset-form" style={{ width: '100%' }}>
          <div className="add-integra-btn">
            <button disabled={disableBTN} className="nf-btn nf-btn-default" onClick={() => redirectFB()}>Login with Facebook</button>
          </div>
        </div>
      </div>
      {/* {userIntegration && userIntegration.length > 0 && <div className="integre-search--list">
        <input
          className="nf-input nf-input-sm input-left-inicon input-left-iconsearch input-left-visitor"
          placeholder="Search by name"
          type="text"
          name="searchByName"
          value={data.searchByName}
          onChange={(e) => handleStateChangeInt(e)}
        />
      </div>} */}
      {loading === true ?
        <ContentLoader
          height={750}
          width={1750}
          speed={2}
          primaryColor="#fff"
          secondaryColor="#eceef4"
        >
          <rect x="150" y="40" rx="0" ry="0" width="1500" height="700"></rect>
        </ContentLoader> :
        userIntegration && userIntegration.length > 0 ?
          userIntegration.map((usInt, key) => {
            // let dataArrFBPage = [];
            // if (usInt.d && usInt.d.fb_page && usInt.d.fb_page.length > 0) {
            //   dataArrFBPage = usInt.d.fb_page;
            //   if (data.searchByName) {
            //     dataArrFBPage = usInt.d.fb_page.filter(x => {
            //       if (new RegExp(data.searchByName, 'i').test(x.name) == true) {
            //         return x;
            //       } else if (!data.searchByName) {
            //         return x;
            //       }
            //     });
            //   }
            // }
            let intPages = [];
            if (usInt.d && usInt.d.fb_page && usInt.d.fb_page.length > 0) {
              for (let i = 0; i < usInt.d.fb_page.length; i++) {
                const element = usInt.d.fb_page[i];
                if (!element.ia) {
                  intPages.push({
                    value: element.instagram_business_account.id, label: element.name
                  });
                }
              }
            }

            //   return (dataArrFBPage && dataArrFBPage.length > 0 && <div className="card-editor card-intigra-block mt-25" key={key}>
            //     <div className="card-editor-block p-0">
            //       <label className="card-editor-title app-intigra-title">{usInt.d && usInt.d.name ? usInt.d.name : ''}</label>
            //       <div className="app-editor-actiontop app-intigra-actiontop">
            //         <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt" onClick={() => deleteInstagram(usInt._id)}>
            //           <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
            //             <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
            //               <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
            //               <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
            //             </g>
            //           </svg>
            //         </span>
            //       </div>
            //       <div className="card-intigra-box">
            //         {dataArrFBPage && dataArrFBPage.length > 0
            //           ? dataArrFBPage.map((pageObj, i) => {
            //             let objCountParams = {
            //               pglkcnt: 0,
            //               pgflcnt: 0,
            //               pgrtngcnt: 0,
            //               pgrtngavg: 0,
            //               pu: '',
            //               iin: usInt.inm,
            //               rmk: pageObj.name,
            //               dn: usInt.d.dn ? usInt.d.dn : ''
            //             };
            //             return <div className="dataset-select-list" key={i}>
            //               <div className="dataset-select-item">
            //                 <div className="secstyle-checkbox  itgtion-icon-checkboc">
            //                   <label>
            //                     <input type="checkbox"
            //                       name={pageObj.id}
            //                       checked={arrDataSource.filter((dataSource) => {
            //                         if (dataSource.uid == usInt._id && dataSource.pid == pageObj.id) return true; return false;
            //                       }).length > 0 ? true : false}
            //                       onChange={(e) => handleDataSource(
            //                         usInt._id,
            //                         pageObj.id,
            //                         e.target.checked,
            //                         objCountParams,
            //                         usInt
            //                       )}
            //                     />
            //                   </label>
            //                 </div>
            //                 <h5>{pageObj.name}</h5>
            //               </div>
            //             </div>;
            //           })
            //           : ''
            //         }
            //       </div>
            //     </div>
            //   </div>);
            // })

            return (<div className="integre-block-part social-login-wrapper">
              <div className="card-editor card-intigra-block mt-25 app-list-sublistapp sublistapp-p20" key={key}>
                <div className="app-list-sublistapp-header">
                  <label className="card-editor-title app-intigra-title">{usInt.d && usInt.d.name ? usInt.d.name : ''}
                    <svg style={{ marginLeft: '10px' }} xmlns="http://www.w3.org/2000/svg" xmlnsxlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 32 32">
                      <defs>
                        <radialGradient id="radial-gradient" cx="0.372" cy="1.001" r="1.247" gradientUnits="objectBoundingBox">
                          <stop offset="0" stop-color="#fd5" />
                          <stop offset="0.328" stop-color="#ff543f" />
                          <stop offset="0.348" stop-color="#fc5245" />
                          <stop offset="0.504" stop-color="#e64771" />
                          <stop offset="0.643" stop-color="#d53e91" />
                          <stop offset="0.761" stop-color="#cc39a4" />
                          <stop offset="0.841" stop-color="#c837ab" />
                        </radialGradient>
                        <radialGradient id="radial-gradient-2" cx="0.161" cy="-0.012" r="0.828" gradientTransform="translate(0 -0.004) scale(1 0.666)" gradientUnits="objectBoundingBox">
                          <stop offset="0" stop-color="#4168c9" />
                          <stop offset="0.999" stop-color="#4168c9" stop-opacity="0" />
                        </radialGradient>
                      </defs>
                      <g id="Group_29083" data-name="Group 29083" transform="translate(-5.99 -5.99)">
                        <path id="Path_59457" data-name="Path 59457" d="M30.89,37.973l-17.768.017a7.129,7.129,0,0,1-7.114-7.1L5.99,13.121a7.129,7.129,0,0,1,7.1-7.114L30.859,5.99a7.129,7.129,0,0,1,7.114,7.1l.017,17.768a7.127,7.127,0,0,1-7.1,7.115Z" fill="url(#radial-gradient)" />
                        <path id="Path_59458" data-name="Path 59458" d="M30.89,37.973l-17.768.017a7.129,7.129,0,0,1-7.114-7.1L5.99,13.121a7.129,7.129,0,0,1,7.1-7.114L30.859,5.99a7.129,7.129,0,0,1,7.114,7.1l.017,17.768a7.127,7.127,0,0,1-7.1,7.115Z" fill="url(#radial-gradient-2)" />
                        <path id="Path_59459" data-name="Path 59459" d="M24,31a7,7,0,1,1,7-7A7,7,0,0,1,24,31Zm0-12a5,5,0,1,0,5,5,5,5,0,0,0-5-5Z" transform="translate(-2.01 -2.01)" fill="#fff" />
                        <circle id="Ellipse_1668" data-name="Ellipse 1668" cx="1.5" cy="1.5" r="1.5" transform="translate(27.078 13.903)" fill="#fff" />
                        <path id="Path_59460" data-name="Path 59460" d="M27.063,32.981H16.918A5.925,5.925,0,0,1,11,27.063V16.918A5.925,5.925,0,0,1,16.918,11H27.063a5.925,5.925,0,0,1,5.918,5.918V27.063a5.925,5.925,0,0,1-5.918,5.918ZM16.918,12.691a4.232,4.232,0,0,0-4.227,4.227V27.063a4.232,4.232,0,0,0,4.227,4.227H27.063a4.232,4.232,0,0,0,4.227-4.227V16.918a4.232,4.232,0,0,0-4.227-4.227Z" fill="#fff" />
                      </g>
                    </svg>
                  </label>
                  <div className="app-sublistapp-actiontop">
                    {/* <div className="btn-action nf-btn light-bg-icon btn-icon-20 mr-3" onClick={() => syncLastestPages(usInt._id)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 25.292 32.141">
              <g id="Group_8471" data-name="Group 8471" transform="translate(-9.074)">
                <path fill="#8fa7c4" id="Path_14194" data-name="Path 14194" d="M42.315,15l-1.557,1.682a10.423,10.423,0,0,1-6.272,19.133l.411-.432h-.025l1.558-1.635-1.439-1.373L31.9,35.618h0l-1.333,1.4,1.438,1.372h0l3.243,3.09,1.334-1.4-2.1-2A12.685,12.685,0,0,0,42.315,15Z" transform="translate(-13.382 -9.339)" />
                <path fill="#8fa7c4" id="Path_14195" data-name="Path 14195" d="M11.467,14.454a10.425,10.425,0,0,1,10.87-8.789l-.411.432h.025L20.392,7.732l1.439,1.373,3.09-3.244h0l1.333-1.4L24.817,3.09h0L21.573,0,20.239,1.4l2.1,2a12.686,12.686,0,0,0-7.832,23.08L16.064,24.8A10.441,10.441,0,0,1,11.467,14.454Z" />
              </g>
            </svg>
          </div> */}
                    {/* <label className="switch">
            <input type="checkbox"
              checked={usInt.ia ? true : false}
              onChange={(e) => handleIsActive(usInt._id, e.target.checked)}
            />
            <span className="slider round"></span>
          </label> */}
                    <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt" onClick={() => deleteInstagram(usInt._id)}>
                      <svg id="Group_29020" data-name="Group 29020" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                        <rect id="Rectangle_135" data-name="Rectangle 135" width="1.264" height="5.509" transform="translate(7.785 5.664)" fill="#f06548" />
                        <path id="Path_162" data-name="Path 162" d="M-127.23,5.132V2.295h-6.927V5.132H-137.7V6.386h2.122V16.3h9.755V6.386h2.123V5.132ZM-128.5,3.559V5.132h-4.41V3.559Zm-5.765,11.482V6.386h7.185v8.655Z" transform="translate(137.699 -2.295)" fill="#f06548" />
                        <rect id="Rectangle_136" data-name="Rectangle 136" width="1.254" height="5.509" transform="translate(4.959 5.664)" fill="#f06548" />
                      </svg>
                    </span>
                  </div>
                </div>
                <div className='app-list-sublistapp-select' style={{ margin: '10px 0px' }}>
                  <Dropdown
                    options={intPages}
                    className="nf-select-dropdown nf-select-defaultdd"
                    onChange={(e) => createInstaPostInt({ pgid: e.value, _id: usInt._id })}
                  />
                </div>
                <div className='sublistapp-connect-block' style={{ marginTop: '16px' }}>
                  <h5 className='title-connection'>Connected Pages</h5>
                </div>
                <div className='integra-data-headerblock'>
                  <label className=''>Name</label>
                  <label className=''>Action</label>
                </div>
                <div className="card-intigra-box review-collection-scroll" style={{ maxHeight: 'calc(100vh - 430px)' }}>
                  {usInt.d && usInt.d.fb_page.length > 0 && usInt.d.fb_page.filter(x => x.ia === true).length > 0 ? usInt.d.fb_page.filter(x => x.ia === true).map((pageObj, i) => {
                    // let objCountParams = {
                    //   pglkcnt: 0,
                    //   pgflcnt: 0,
                    //   pgrtngcnt: pageObj.totalReviewCount,
                    //   pgrtngavg: pageObj.averageRating,
                    //   pu: pageObj.placeID,
                    //   iin: usInt.inm,
                    //   rmk: pageObj.locationName,
                    //   dn: usInt.d.dn ? usInt.d.dn : ''
                    // };
                    // if (pageObj.isListen === true) {
                    //   return <div className="dataset-select-list" key={i}>
                    //     <div className="dataset-select-item">
                    //       <ContentLoader
                    //         height={200}
                    //         width={1750}
                    //         speed={2}
                    //         primaryColor="#fff"
                    //         secondaryColor="#eceef4"
                    //         key={key}
                    //       >
                    //         <rect x="10" y="40" rx="0" ry="0" width="150" height="150"></rect>
                    //         <rect x="220" y="40" rx="0" ry="0" width="1500" height="150"></rect>
                    //       </ContentLoader>
                    //     </div>
                    //   </div>;
                    // } else {
                    usInt.d['filData'] = pageObj;
                    return <div className="dataset-select-list" key={i}>
                      <div className="dataset-select-item">
                        {/* <div className="secstyle-checkbox secstyle-checkbox-sm  itgtion-icon-checkboc">
                      <label>
                        <input type="checkbox"
                          name={pageObj.locationName}
                          checked={arrDataSource.filter((dataSource) => {
                            if (dataSource.uid == usInt._id && dataSource.pid == pageObj.name) return true; return false;
                          }).length > 0 ? true : false}
                          onChange={(e) => handleDataSource(
                            usInt._id,
                            pageObj.name,
                            e.target.checked,
                            objCountParams,
                            usInt
                          )}
                        />
                      </label>
                    </div> */}
                        <h5>{pageObj.name}</h5>
                        <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt" onClick={() => deleteInstaPostInt({ pgid: pageObj.instagram_business_account.id, _id: usInt._id })}>
                          <svg id="Group_29020" data-name="Group 29020" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                            <rect id="Rectangle_135" data-name="Rectangle 135" width="1.264" height="5.509" transform="translate(7.785 5.664)" fill="#f06548" />
                            <path id="Path_162" data-name="Path 162" d="M-127.23,5.132V2.295h-6.927V5.132H-137.7V6.386h2.122V16.3h9.755V6.386h2.123V5.132ZM-128.5,3.559V5.132h-4.41V3.559Zm-5.765,11.482V6.386h7.185v8.655Z" transform="translate(137.699 -2.295)" fill="#f06548" />
                            <rect id="Rectangle_136" data-name="Rectangle 136" width="1.254" height="5.509" transform="translate(4.959 5.664)" fill="#f06548" />
                          </svg>
                        </span>
                        <span className="btn-action nf-btn light-bg-icon btn-icon-20  tbl-action-dlt" style={{ display: 'none' }}
                        // onClick={() => openReviewModel(usInt)}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="12.414" height="7.4" viewBox="0 0 12.414 7.4">
                            <path id="Path_14253" data-name="Path 14253" d="M6.207,98.725A7.744,7.744,0,0,0,.1,102.13a.491.491,0,0,0,0,.587,7.74,7.74,0,0,0,6.11,3.408,7.744,7.744,0,0,0,6.11-3.405.491.491,0,0,0,0-.587A7.74,7.74,0,0,0,6.207,98.725Zm.17,6.305A2.611,2.611,0,1,1,8.812,102.6,2.613,2.613,0,0,1,6.377,105.03Zm-.079-1.2a1.406,1.406,0,1,1,1.313-1.313A1.4,1.4,0,0,1,6.3,103.827Z" transform="translate(0 -98.725)" fill="#8392a5" />
                          </svg>
                        </span>
                      </div>
                    </div>;
                    // }
                  }) : <div className="dataset-select-list">
                    <div className="dataset-select-item">
                      <h5> No record found</h5>
                    </div>
                  </div>
                  }
                </div>

              </div>
              {usInt && usInt.d && usInt.d.fbTokenError && usInt.d.fbTokenError !== '' && <div className='social-login-issues social-login-insta'>
                <div className='modal-logissue-wrap'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="38" height="32.458" viewBox="0 0 38 32.458">
                    <g id="Group_32090" data-name="Group 32090" transform="translate(7909.332 -10006.506)">
                      <path id="Polygon_7" data-name="Polygon 7" d="M16.411,4.423a3,3,0,0,1,5.178,0l13.768,23.52a3,3,0,0,1-2.589,4.516H5.232a3,3,0,0,1-2.589-4.516Z" transform="translate(-7909.332 10006.506)" fill="#fb5360" />
                      <g id="Group_32089" data-name="Group 32089" transform="translate(-7892.236 10018.56)">
                        <path id="Path_59652" data-name="Path 59652" d="M-.983,0H1.835L1.261,10.143H-.429Z" transform="translate(1.302)" fill="#fff" />
                        <circle id="Ellipse_1756" data-name="Ellipse 1756" cx="1.5" cy="1.5" r="1.5" transform="translate(0 12.036)" fill="#fff" />
                      </g>
                    </g>
                  </svg>
                  <p className='modal-logissue-text'>{usInt.d.fbTokenError.split(':')[0]}:</p>
                  <p className='modal-logissue-text mb-4' >{usInt.d.fbTokenError.split(':')[1]}
                  </p>
                  <span className='error-btn error-btn-insta' onClick={() => redirectFB()}>Login With Facebook </span>
                </div>
              </div>}
            </div>);
          })
          : ''
      }
    </div>
  );
};

export default InstaPost;




// WEBPACK FOOTER //
// ./src/components/Integration/InstaPost.js